import * as React from 'react';
import { render } from 'react-dom';
import { Global } from '@emotion/core';

import App from './App';
import * as styles from './styles';

const root = document.getElementById('root');
const load = () =>
  render(
    <React.Fragment>
      <Global styles={[styles.normalize, styles.grid, styles.header, styles.login, styles.appbar, styles.dashboard, styles.modals]} />
      <App />
    </React.Fragment>,
    root,
  );

load();
